import LocalizedStrings from "react-localization";
import english from "./englishLang";
import hindiLang from "./hindiLang";

const languages = {
  english: english,
  hindiLang: hindiLang,
}

export let strings = new LocalizedStrings({
  en: english,
  hi: hindiLang,
})

export default languages;